export enum HeaderIds {
  UNDO_REDO = 'undoRedo',
}
